<template>
  <div class="container">
    <div v-if="!pagina">
      <div class="card card-muni card-muni-min">
        <h3>Iniciar sesión</h3>
        <div class="row justify-content-center">
          <div class="col-12 col-sm-6 col-md-12">
            <div class="mt-1 line15">
              <label>Correo electrónico</label>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-12">
            <input name="user" type="text" class="form-control" v-model="correo" />
          </div>
        </div>
        <router-link class="enlace4" to="/busca-correo">¿Olvidaste tu correo electrónico?</router-link>
        <div class="row justify-content-center mt-2">
          <div class="col-12 col-sm-6 col-md-12">
            <div class="mt-2">
              <label>Contraseña</label>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-12">
            <input name="pass" type="password" class="form-control" v-model="contrasena" @keyup.enter="IniciarSesion" />
          </div>
        </div>
        <router-link class="enlace4" to="/recupera">¿Olvidaste tu contraseña?</router-link>
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-12 text-center mt-3">
            <button @click="IniciarSesion" name="ingresar" class="btn btn-block btn-lg btn-default">Ingresar</button>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-12">
            <hr />
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-12 text-center">
            ¿ Aún no tienes cuenta ?
            <router-link class="enlace4" to="/registroUsuarioOption">Regístrate</router-link>
          </div>
        </div>

      </div>
      <footer class="text-muted text-center mt-3">{{ version }}</footer>
    </div>
    <!-- <div v-if="pagina">
      <div class="card card-muni card-muni-min" style="padding:20px">
        <div class="col-12 error-msg">
           <img src="https://www.miraflores.gob.pe/wp-content/themes/munimiraflores/web-imagenes/error404.png" class="img-fluid" alt="Error 404"> 
          <img src="../../assets/imagen_mantenimiento.png" class="img-fluid" alt="Error 404">
        </div> 
        <h2 class="display-6" style="text-align:center;color:#0078cf;">Plataforma en mantenimiento</h2>
          <p class="lead" style="font-size:18px;text-align:center;">Disculpas por las molestias</p>
          <p class="lead" style="font-size:15px;text-align:center;">Municipalidad de Miraflores</p>
      </div> 
    </div>  -->
  </div>
</template>
<script>
import GlobalEventBus from "../../helpers/EventBus.js";
import axios from "axios";
import Constantes from "../../store/constantes.js";
import Util from "../../tools/util";

import { getAccesoLogin } from "../services/rentasService";
import constantes from "../../store/constantes.js";
import { mapMutations } from 'vuex'
export default {
  name: "Login",
  data() {
    return {
      pagina: Constantes.mantenimiento,
      version: constantes.version,
      correo: "",
      contrasena: "",
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },
  props: {
    showModal: false
  },
  created() {
    window.rutaReturn = window.rutaReturn ? window.rutaReturn : "/";
  },
  mounted() {
    localStorage.setItem("logueadoTramite", false);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pagina_vista",
      "page-url": "/login/",
      "page-title": "login",
    });
  },
  methods: {
    ValidaCorreoFormato(correo) {
      return correo === "" ? false : this.reg.test(correo);
    },
    ValidarFormulario() {
      if (this.correo === "") {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Ingrese cuenta de usuario"
        });
        return false;
      }
      if (this.contrasena === "") {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Ingrese su contraseña"
        });
        return false;
      }
      return true;
    },
    IniciarSesion() {
      if (this.ValidarFormulario()) {
        /*let PtdGenUsuarioLogin = { 'email': this.correo, 'clave': this.contrasena }
        const urlValidacion =Constantes.rutaAccesos +"acceso/obtener/";
        axios.post(urlValidacion,PtdGenUsuarioLogin)*/

        var bodyFormData = new FormData();
        bodyFormData.append('username', this.correo);
        bodyFormData.append('password', this.contrasena);
        bodyFormData.append('grant_type', 'password');
        const urlValidacion = Constantes.rutaOauth;
        axios.post(urlValidacion, bodyFormData, {
          headers: {
            Authorization: 'Basic ' + btoa(Constantes.Authorization)
          }
        }).catch(error =>
          console.log(error)
        ).then(response => {
            if (response.toString().toUpperCase() === ("Error: Request failed with status code 400").toUpperCase()
          ||response.toString().toUpperCase() === ("Error: Request failed with status code 401").toUpperCase()) {
              this.controlErrorSesion(404);
            } else {
              if (response.data.success) {
                const data = response.data.data;
                localStorage.setItem('idVerificador', 1);
                localStorage.setItem("logueadoTramite", true);
                localStorage.setItem("nombreUsuarioLogueadoTramite", data.nombre);
                localStorage.setItem("fagCancha", data.flagAlquilerCancha);
                localStorage.setItem("paternoUsuarioLogueadoTramite", data.apePaterno);
                localStorage.setItem("maternoUsuarioLogueadoTramite", data.apeMaterno);
                localStorage.setItem("idUsuarioLogueadoTramite", data.idUsuario);
                localStorage.setItem("cuentaTrmaite", this.correo);
                localStorage.setItem("idPersonaLogueadoTramite", data.idPersona);
                localStorage.setItem("nombreCompletoLogueadoTramite", data.apePaterno +
                  " " + data.apeMaterno + " " + data.nombre);
                localStorage.setItem("numeroDocumentoLogueadoTramite", data.numeroDocumento);
                localStorage.setItem("correoNotificacionTramite", data.emailNotificacion);
                localStorage.setItem("restricciones", JSON.stringify(data.restricciones));
                Util.storage.set("usuarioMigrado", true);
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("jwt", response.data.access_token);
                localStorage.setItem("expires_in", response.data.expires_in);

                let appRentas = {};
                appRentas.contribuyente = {};
                appRentas.contribuyente.numDoc = data.numeroDocumento;
                appRentas.contribuyente.nombres = data.apePaterno + " " + data.apeMaterno + ", " + data.nombre;
                appRentas.contribuyente.email = this.correo;
                Util.storage.set("appRentas", appRentas);
                GlobalEventBus.$emit("login", data.nombre);
                //this.obtenerListadoDeshabilitado();              
                this.$router.push(window.rutaReturn);
              } else if (response.data.existeUsuario) {
                if (response.data.activado) {
                  this.controlErrorSesion(404);
                } else {
                  this.controlErrorSesion(405);
                }
              } else {
                let dataLogin = {};
                dataLogin.email = this.correo;
                dataLogin.pass = this.contrasena;
                let mensajeLogin = response.data.message;
                localStorage.setItem("logueadoTramite", false);
                this.$swal({
                  icon: "error",
                  title: "Error",
                  text:
                    mensajeLogin === "" || mensajeLogin == null
                      ? "Verifique datos"
                      : mensajeLogin
                });
              }
            }
          })
          ;
      }
    },
    obtenerListadoDeshabilitado() {
      var url = Constantes.rutacitas + "obtener-horarios-no-disponibles";
      axios
        .get(url)
        .then((response) => {
          var respuesta = response.data.lista;
          if (respuesta.length > 0) {
            // localStorage.setItem("listaNoDisponible", respuesta);
          }
        })
        .catch((e) =>
          console.log(e)
        );
    },
    validaUsuarioRentas(data) {
      let respuesta = true;
      if (data.tipDoc !== 32 && (data.nombre.trim() + data.apePat.trim() + data.apeMat.trim() === '')) {
        respuesta = false;
      }
      if (data.tipDoc === 32 && (data.nombre.trim() + data.apePat.trim() + data.apeMat.trim() === '')) {
        respuesta = false;
      }
      return respuesta;
    },
    lanzaServicio(requestParams, nombreLogin) {
      if (requestParams.opcion === 0) {
        this.$router.push("/");
      } else if (requestParams.opcion === 1) {
        this.$router.push("/tramiteVirtual");
      } else if (requestParams.opcion === 2) {
        this.$router.push("/consultaTramite");
      } else if (requestParams.opcion === 5) {
        this.$router.push(
          "/tramite/ce/" +
          localStorage.getItem("areaTramite") +
          "&" +
          localStorage.getItem("tipoTramite") +
          "&" +
          localStorage.getItem("idTramite") +
          "&0&0"
        );
      } else if (requestParams.opcion === "pago-tributo") {
        this.$router.push("/pago-tributo");
      } else if (requestParams.opcion === "estado-cuenta") {
        this.$router.push("/estado-cuenta");
      }

      GlobalEventBus.$emit("login", nombreLogin);
    },
    controlErrorSesion(codigoError) {
      if (codigoError === 404) {
        this.$swal({
          icon: 'error',
          title: 'Error de inicio de sesión',
          html: "El usuario y/o la contraseña ingresados son incorrectos"
        });
      } else if (codigoError === 40401) {
        let mensaje = "<div style='line-height:24px;'>Por las mejoras realizadas en nuestra plataforma on line, solo podrán ingresar ";
        mensaje += "los contribuyentes registrados, para mayor información comuníquese al teléfono ";
        mensaje += "<br/><b>(01) 617-7555</b></div>";

        this.$swal({
          icon: 'warning',
          title: 'Alerta',
          html: mensaje
        });
      } else if (codigoError === 405) {
        this.$swal({
          icon: 'error',
          title: 'Error de inicio de sesión',
          html: "Debe activar su cuenta. Favor revise su correo electrónico."
        });
      } else if (codigoError === 500) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: 'Ocurrio un error inesperado'
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Inicio/Login.vue